<script setup lang="ts">
import ColumnsBlock from '@/shared/ui/ColumnsBlock/index';
import type { DropdownProps } from '@/shared/ui/AppBreadcrumbs/model/types/appBreadcrumbs';

defineOptions({
  name: 'AppBreadcrumbsDropdown',
});

const props = withDefaults(defineProps<DropdownProps>(), {
  dropdownTitle: '',
  dropdownItems: () => [],
});

const isMobile: boolean = useIsMobile();

const columnsGap: ComputedRef<number> = computed(() => (isMobile ? 12 : 80));
const isShowDivider: ComputedRef<string> = computed(() =>
  props.dropdownItems.length > 8 ? 'block' : 'none',
);
</script>

<template>
  <div :class="['breadcrumbs-dropdown', { _mobile: isMobile }]">
    <div class="breadcrumbs-dropdown__title">
      {{ dropdownTitle }}
    </div>
    <ColumnsBlock
      :key="dropdownItems.length"
      class="breadcrumbs-dropdown__columns"
      :items="dropdownItems"
      :columns-count="2"
      :count-in-column="8"
      :gap="columnsGap"
      key-name="dropdown"
    />
  </div>
</template>

<style lang="less">
.breadcrumbs-dropdown {
  .flex-column(@size-x3);
  .box-shadow();

  background-color: white;
  padding: @size-x5;
  border: 1px solid @color-gallery;
  border-radius: @main-size;
  width: 100%;

  &__title {
    font-size: @size-x4;
    line-height: 21px;
    font-weight: 700;
  }

  .columns-block__column {
    row-gap: @size-x3;
    position: relative;

    &:not(:last-child) {
      &::after {
        content: '';
        display: v-bind(isShowDivider);
        position: absolute;
        width: 1px;
        background-color: @color-gallery;
        height: 100%;
        right: -@size-x10;
      }
    }
  }

  .columns-block__column-item {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    position: relative;
    white-space: nowrap;

    &:hover:not(:last-child) {
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: -@main-size;
        width: 2px;
        height: 100%;
        background-color: @color-persimmon;
        border-radius: @main-size;
      }
    }

    &._selected {
      font-weight: 700;

      &::before {
        content: '';
        display: block;
        position: absolute;
        left: -@main-size;
        width: 2px;
        height: 100%;
        background-color: @color-persimmon;
        border-radius: @main-size;
      }
    }
  }

  &._mobile .columns-block__column::after {
    display: none;
  }

  &._mobile .columns-block {
    flex-wrap: wrap;
  }

  &._mobile .columns-block__column-item {
    white-space: normal;
  }
}
</style>
